/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { capitalizeWords } from '../../../utilities/capitalizeWords';
import {
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
} from '@mui/material';
import { CustomTableCell } from '../../index';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
export const Addresses = (props) => {
  return (
    <Box sx={{ mb: 3, padding: '12px' }}>
      <TableContainer
        sx={{
          height: '100%',
          width: '100%',
          overflow: 'auto',
          padding: '12px',
        }}
      >
        <Table sx={{ width: '100%' }}>
          <TableHead>
            <TableRow>
              <CustomTableCell value="Unit Number" />
              <CustomTableCell value="Lot Number" />
              <CustomTableCell value="House/Building Number" />
              <CustomTableCell value="Street" />
              <CustomTableCell value="Barangay" />
              <CustomTableCell value="Subdivision" />
              <CustomTableCell value="City" />
              <CustomTableCell value="Province" />
              <CustomTableCell value="Region" />
              <CustomTableCell value="ZIP" />
              <CustomTableCell value="Country" />
              <CustomTableCell value="Residential" />
              <CustomTableCell value="Permanent" />
              <CustomTableCell value="Telephone No." />
            </TableRow>
          </TableHead>
          {props.empAddresses?.map((address) => (
            <TableRow key={address._id}>
              <TableCell>{address.unitnumber}</TableCell>
              <TableCell>{address.lotnumber}</TableCell>
              <TableCell>{address.housebldgnum}</TableCell>
              <TableCell>{capitalizeWords(address.street)}</TableCell>
              <TableCell>{capitalizeWords(address.barangay)}</TableCell>
              <TableCell>{capitalizeWords(address.subdivision)}</TableCell>
              <TableCell>{capitalizeWords(address.city)}</TableCell>
              <TableCell>{capitalizeWords(address.province)}</TableCell>
              <TableCell>{address.region}</TableCell>
              <TableCell>{address.zipcode}</TableCell>
              <TableCell>{capitalizeWords(address.country)}</TableCell>
              <TableCell>
                {address.isresidential ? (
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <CheckCircleIcon />
                  </Box>
                ) : null}
              </TableCell>

              <TableCell>
                {address.ispermanent ? (
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <CheckCircleIcon />
                  </Box>
                ) : null}
              </TableCell>
              <TableCell>{address.telephone}</TableCell>
            </TableRow>
          ))}
        </Table>
      </TableContainer>
    </Box>
  );
};
